<template>
  <div class="comp">
    <div class="comp-container">
      <form @submit.prevent="submit" class="input-components">
        <h2>احراز هویت</h2>
        <PersonalInfo
          v-if="!noSee"
          :data.sync="userInfo"
          :countryName="countryName"
        />
        <ShowPersonalInfo v-if="noSee" :data.sync="userInfo" />
        <PhoneInfo
          :data.sync="userInfo"
          :countryName="countryName"
          :countryPhoneCode="countryPhoneCode"
        />
        <BankInfo :data.sync="userInfo" />
        <UploadPic :data.sync="userInfo" :idType="idType" />
        <!-- v-if="state.userInfo.authenticationType !== 'AUTHORIZED'" -->
        <button :disabled="!!disabled" class="submit">
          {{ !!disabled ? disabled : " ثبت و ارسال اطلاعات " }}
        </button>
      </form>
      <div v-if="!noSee" class="guide">
        <img src="../../../assets/accountGuide.svg" alt="" />
        <div class="guide-texts">
          <div class="text-container">
            <h3>اطلاعات شخصی</h3>
            <span class="guide-body">
              اطلاعات شخصی باید بر اساس مدارک شناسایی تکمیل شوند در غیر این صورت
              احراز هویت با خطا مواجه خواهد شد
            </span>
          </div>
          <div class="text-container">
            <h3>اطلاعات تماس</h3>
          </div>
          <div class="text-container">
            <h3>اطلاعات بانکی</h3>
            <span class="guide-body"> حداقل یک حساب بانکی معرفی کنید </span>
          </div>
          <div class="text-container">
            <h3>آپلود مدارک</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PersonalInfo from "./PersnalInfo.vue";
import ShowPersonalInfo from "./ShowPersonalInfo.vue";
import PhoneInfo from "./PhoneInfo.vue";
import BankInfo from "./BankInfo.vue";
import UploadPic from "./UploadPic.vue";
const inputLabel = {
  firstName: "نام",
  lastName: "نام خانوادگی",
  email: "ایمیل",
  birthDay: "تاریخ تولد",
  mobileNumber: "شماره موبایل",
  telephone: "تلفن ثابت",
  address: "آدرس",
  image: "عکس سلفی",
  nationalCode: "کد ملی",
  city: "شهر",
  state: "استان",
  postalCode: "کد پستی",
  backImage: "عکس پشت کارت ملی",
};

export default {
  name: "Account",
  metaInfo: {
    title: "حساب کاربری",
  },
  components: {
    PersonalInfo,
    PhoneInfo,
    BankInfo,
    UploadPic,
    ShowPersonalInfo,
  },
  data() {
    return {
      userInfo: {
        authenticationType: "",
        firstName: "",
        lastName: "",
        email: "",
        nationalCode: "",
        birthDay: "",
        mobileNumber: "",
        telephone: "",
        countryName: "",
        city: "",
        state: "",
        postalCode: "",
        address: "",
        image: "",
        backImage: "",
        idFormatType: "",
        profileImage: "",
        bankAccounts: [
          {
            shebaCode: "",
            cardNumber: "",
            bankName: "",
          },
        ],
        identityType: "",
      },
      idType: "ID_CARD",
      countryName: "",
      countryPhoneCode: "",
    };
  },
  computed: {
    noSee() {
      return this.state.userInfo.authorized;
    },
    disabled() {
      const items = [
        "firstName",
        "lastName",
        "email",
        "nationalCode",
        "birthDay",
        "mobileNumber",
        "city",
        "state",
        "postalCode",
        "address",
        "image",
      ];
      if (this.isIran) {
        items.push("telephone");
        items.push("bankAccounts");
      }
      if (!this.userInfo.backImage && this.idType == "ID_CARD") {
        items.push("backImage");
      }
      for (let key in this.userInfo) {
        if (items.includes(key)) {
          if (key === "bankAccounts") {
            if (this.userInfo.bankAccounts.length) {
              for (let data of this.userInfo.bankAccounts) {
                if (
                  !data.shebaCode ||
                  !data.cardNumber ||
                  data.cardNumber.replace(/-/g, "").length < 16 ||
                  data.shebaCode.length < 24
                ) {
                  return "اطلاعات بانکی اشتباه است";
                }
              }
            } else {
              return "اطلاعات بانکی اجباریست";
            }
          } else if (
            key == "telephone" &&
            (!this.userInfo[key] || this.userInfo[key].length !== 11)
          ) {
            return "تلفن ثابت صحیح وارد کنید";
          } else if (
            key == "nationalCode" &&
            this.isIran &&
            (!this.userInfo[key] || this.userInfo[key].length !== 10)
          ) {
            return "کد ملی صحیح وارد کنید";
          } else if (!this.userInfo[key]) {
            return inputLabel[key] + " اجباریست";
          }
        }
      }
      return false;
    },
    isIran() {
      return this.countryName == "Iran";
    },
  },
  methods: {
    dataURLtoFile(dataurl, filename) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },
    async submit() {
      if (this.state.loading) return;
      this.state.loading = true;
      this.userInfo.idFormatType = this.idType;
      delete this.userInfo.location;
      if (!this.userInfo.backImage) {
        delete this.userInfo.backImage;
      }
      // if(this.userInfo.image === 'string') delete this.userInfo.image
      // this.data.languageList = this.languages
      let form_data = new FormData();
      let editBody = {};

      for (let key in this.userInfo) {
        if (key == "mobileNumber") {
          form_data.append(
            "mobileNumber",
            // this.countryPhoneCode + this.userInfo.mobileNumber
            this.countryPhoneCode + this.userInfo.mobileNumber.slice(1, 11)
          );
        } else if (key === "image") {
          if (typeof this.userInfo.image !== "string") {
            form_data.append("image", this.userInfo.image);
          } else {
            form_data.append(
              "image",
              this.dataURLtoFile(this.userInfo.image, "image")
            );
          }
        } else if (key === "backImage") {
          if (typeof this.userInfo.backImage !== "string") {
            form_data.append("backImage", this.userInfo.backImage);
          } else {
            form_data.append(
              "backImage",
              this.dataURLtoFile(this.userInfo.backImage, "backImage")
            );
          }
        } else if (
          key === "backImage" &&
          this.userInfo.idFormatType !== "PASSPORT"
        ) {
          if (typeof this.userInfo.backImage !== "string") {
            form_data.append("backImage", this.userInfo.backImage);
          }
        } else if (
          key === "backImage" &&
          this.userInfo.idFormatType === "PASSPORT"
        ) {
          delete this.userInfo.backImage;
        } else if (key !== "bankAccounts") {
          // console.log(key ,  this.userInfo[key])
          form_data.append(key, this.userInfo[key]);
          editBody[key] = this.userInfo[key];
        }
      }

      form_data.append(
        "bankAccountsString",
        JSON.stringify(this.userInfo.bankAccounts)
      );
      editBody.bankAccountsString = JSON.stringify(this.userInfo.bankAccounts);
      // this.userInfo.languages = JSON.stringify(this.userInfo.languages)

      // if (this.bankCheck(this.userInfo.bankAccounts)) {

      try {
        let res = null;
        if (
          ["UNAUTHORIZED", "UNIDENTIFIED", "NOT_COMPLETE"].includes(
            this.userInfo.authenticationType
          )
        ) {
          res = await this.$axios.post("/users/account", form_data);
        } else {
          res = await this.$axios.put("/users/account", editBody);
        }

        this.state.userInfo.authenticationType = res.baseDTO.authenticationType;
        this.state.userInfo.email = res.baseDTO.email;
        this.state.userInfo.authorized =
          res.baseDTO.authenticationType === "AUTHORIZED" ||
          res.baseDTO.authenticationType === "INFORMATION_CHANGED_PENDING";
        this.state.userInfo.pending =
          res.baseDTO.authenticationType === "PENDING";
        await this.$error("", "اطلاعات با موفقیت ذخیره شد", "success");

        if (this.isIran) {
          if (res.message.includes("need to be verified")) {
            this.state.loading = true;
            await this.$axios(
              `/finnotech/send-sms-to-customer?email=${this.userInfo.email}`
            );
            this.$router.push("/panel/fino-verifying");
          } else {
            this.$router.push("/");
          }
        } else {
          this.$router.push("/");
        }

        this.$getuserInfo();
      } catch (e) {
        if (
          e.response &&
          e.response.data.message.includes(
            "ShebaCode or CardNumber Is For Another User"
          )
        ) {
          this.$error("", "این حساب بانکی قبلا ثبت شده است");
          this.duplicateBank = e.response.data.message;
        }
      }
      this.state.loading = false;
    },
    async check() {
      this.state.loading = true;

      const res = await this.$axios("/users/account");
      this.userInfo = res.baseDTO;
      const location = this.userInfo.location;
      if (location) {
        this.countryModal = false;
        this.userInfo = { ...this.userInfo, ...location };
        this.userInfo.countryName = location.country.countryName;
        this.userInfo.countryPhoneCode = location.country.countryPhoneCode;
        this.countryName = location.country.countryName;
        this.countryPhoneCode = location.country.countryPhoneCode;
        this.changeCountry(this.userInfo.location.country);
      } else {
        this.$axios.post("/users/set-country", {
          countryName: "Iran",
        });
        this.userInfo.countryName = "Iran";
        this.countryName = "Iran";
        this.countryPhoneCode = "+98";
        this.userInfo = { ...this.userInfo, city: "", state: "" };
      }

      if (res.baseDTO.idFormatType) {
        this.idType = res.baseDTO.idFormatType;
      }
      this.change++;
    },
    changeCountry(county) {
      this.countryName = county.countryName;
      this.countryPhoneCode = county.countryPhoneCode;
      this.userInfo.countryName = county.countryName;
    },
  },
  mounted() {
    this.check();
  },
};
</script>

<style lang="scss" scoped>
.input-components {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  width: 30%;
}
.guide {
  display: flex;
  flex-direction: row;
  column-gap: 12px;
  width: 15%;
  position: sticky;
  top: 50px;
  .guide-texts {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    span {
      font-size: clamp(10px, 1vw, 12px);
    }
  }
  @media (max-width: 1000px) {
    position: unset;
  }
}
h2 {
  font-size: clamp(16px, 2vw, 20px);
}
.comp-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  row-gap: 16px;
  align-items: flex-start;
  justify-content: space-around;
}
.comp {
  min-height: 92vh;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
@media only screen and (max-width: 1200px) {
  .input-components {
    width: 50%;
  }
}
@media only screen and (max-width: 1000px) {
  .comp-container {
    flex-direction: column;
  }
  .input-components {
    width: 95%;
  }
  .guide {
    width: 100%;
    order: -1;
  }
}
</style>
